var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 440C512 479.75 479.75 512 440 512H72C32.25 512 0 479.75 0 440C0 404.125 26.25 374.625 60.625 369.125C43.375 356 32 335.375 32 312C32 272.25 64.25 240 104 240H118.125C104.625 228.25 96 211.25 96 192C96 156.625 124.625 128 160 128H176C220.125 128 256 92.125 256 48C256 30.625 250.25 14.625 240.875 1.5C245.875 0.75 250.875 0 256 0C309 0 352 43 352 96C352 107.25 349.75 118 346.125 128H352C387.375 128 416 156.625 416 192C416 211.25 407.375 228.25 393.875 240H408C447.75 240 480 272.25 480 312C480 335.375 468.625 356 451.375 369.125C485.75 374.625 512 404.125 512 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoop);
export default __webpack_public_path__ + "static/media/poop.988cc99a1a57ab1b1bcd7484ef5776a8.svg";
export { ForwardRef as ReactComponent };